export default __webpack_public_path__ + "static/media/popularService(3).534e7f4a.png";